var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlayArrowOutline = function SvgPlayArrowOutline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2516 1.88091C2.25162 1.88093 2.25154 1.88157 2.25132 1.88277C2.25148 1.88149 2.25159 1.88089 2.2516 1.88091ZM1.83065 2.11309C1.83064 2.11306 1.83135 2.11334 1.8328 2.11403C1.83139 2.11347 1.83066 2.11312 1.83065 2.11309ZM2.25 2.37684L9.54504 6.99967L2.25 11.6225V2.37684ZM1.82966 11.8868C1.82968 11.8867 1.83052 11.8863 1.83216 11.8857C1.83047 11.8865 1.82965 11.8868 1.82966 11.8868ZM2.25135 12.1173C2.25163 12.1187 2.25172 12.1195 2.2517 12.1195C2.25168 12.1196 2.25154 12.1188 2.25135 12.1173ZM1.36308 0.760885C1.83388 0.503083 2.32921 0.651215 2.66249 0.86241L10.5866 5.8839C10.9469 6.11223 11.2504 6.49829 11.25 7.00048C11.2496 7.50223 10.9461 7.88765 10.5866 8.11545L2.66249 13.1369C2.3301 13.3476 1.83436 13.4975 1.36263 13.2391C0.889867 12.9802 0.75 12.4805 0.75 12.0858V1.9135C0.75 1.51765 0.891195 1.01928 1.36308 0.760885Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayArrowOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play-arrow-outline.8a4f3f47.svg";
export { ForwardRef as ReactComponent };